export default {
  SHARED_FOOTER_SIMPLE: {
    COPYRIGHT: '© {{year}}, Legal Labs Kft.',
    TERMS_AND_CONDITIONS: 'Všeobecné obchodné podmienky',
    PRIVACY_POLICY: 'Zásady ochrany osobných údajov',
    HELP: 'Pomoc',
  },
};

